import React, { Component } from 'react';

import './SobreRelatorio.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import renderHTML from 'react-render-html';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	relatorio_content
} from '../../settings';

class SobreRelatorio extends Component {

	constructor() {
		super();

        this.images = images;
        this.relatorio_content = relatorio_content;

        this.state = {
            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('08 Sobre o relatório');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'sobre-relatorio'
		];

		// Icon Columns - Assembleia
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

		const iconsHtml = [];
		for (let i = 0; i < this.relatorio_content.line1.length; i++) {
			iconsHtml.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.relatorio_content.line1[i].image } />
					</div>
					<div className="content">
		    			<p className="text">{ renderHTML(this.relatorio_content.line1[i].text) }</p>
					</div>
				</div>
			);
		}

		var outputIconsHtml;
		if (isMobile) {
			outputIconsHtml = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
								    { iconsHtml }
								</Carousel>;
		} else {
			outputIconsHtml = iconsHtml;
		}

		const iconsHtml2 = [];
		for (let i = 0; i < this.relatorio_content.line2.length; i++) {
			iconsHtml2.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.relatorio_content.line2[i].image } />
					</div>
					<div className="content">
		    			<p className="text">{ renderHTML(this.relatorio_content.line2[i].text) }</p>
					</div>
				</div>
			);
		}

		var outputIconsHtml2;
		if (isMobile) {
			outputIconsHtml2 = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
								    { iconsHtml2 }
								</Carousel>;
		} else {
			outputIconsHtml2 = iconsHtml2;
		}


        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>08 Sobre o relatório - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>08</span> Sobre o relatório</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Sobre o relatório</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h3>Esta publicação…</h3>

					        			<div className="icon_columns row">
						        			{ outputIconsHtml }
					        			</div>
				        			</Fade>
				        		</div>
			        		</div>
			        	</div>

		        		<div className="views__content second__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
					        			<div className="icon_columns row">
						        			{ outputIconsHtml2 }
					        			</div>
				        			</Fade>
				        		</div>
			        		</div>
			        	</div>

		        		<div className="views__content last__view row">
			        		<div className="container">
				        		<div className="column column--padding">
				        			<Fade bottom>
					        			<p>
					        				Dúvidas com relação ao Relatório Anual 2018 podem ser esclarecidas pelo e-mail <strong><a href="mailto:comunicacao@anbima.com.br" className="beauty-a">comunicacao@anbima.com.br</a></strong>.
						        			<br />
						        			<br />
					        				<span className="gri_label"><text>GRI 102-53</text></span>
					        			</p>
				        			</Fade>
				        		</div>
			        		</div>
			        	</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { SobreRelatorio };
